import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { AccountingManualTransactionsDto } from "../../../../dtos/documents/AccountingManualTransactions/AccountingManualTransactionsDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFPlainText } from "../../../Shared/NewForms/NFPlainText";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFLookupVendor } from "../../../Shared/NewForms/NFLookupVendor";
import { NFLookupBankAcquirer } from "../../../Shared/NewForms/NFLookupBankAcquirer";
import { AccountingManualTransactionsModel } from "../../../../models/Documents/AccountingManualTransactions/AccountingManualTransactionsModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import * as XLSX from "xlsx";
import { importFromExcel, saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { AppEntities } from "../../../../config/entities";

import { useAppSelector } from "../../../../redux/hooks/hooks";
import useRunError from "../../../Shared/useRunError";
import { selectSubmitCounter } from "../../../../redux/slices/submitCounterSlice";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import AccountingManualTransactionsDetailSkeleton from "./AccountingManualTransactionsDetailSkeleton";
import { AccountingManualTransactionsDetailFooter } from "./AccountingManualTransactionsDetailFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: AccountingManualTransactionsDto | null;
  modelUpdatedEvent: (newModel: AccountingManualTransactionsDto) => void;
}

export const AccountingManualTransactionsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Accounting Manual Transactions");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid, isDirty, dirtyFields },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<AccountingManualTransactionsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const watchProducts = watch("transactions");

  useEffect(() => {
    console.log(model);
    register("transactions");
    if (model) {
      setValue("id", model.id);
      setValue("documentDate", model.documentDate);
      setValue("documentNumber", model.documentNumber);
      setValue("createdDate", model.createdDate);
      setValue("companyId", model.companyId);
      setValue("comment", model.comment);
      setValue("transactions", model.transactions);
    }
  }, [model]);

  useEffect(() => {
    console.log(watchProducts);
  }, [watchProducts]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: AccountingManualTransactionsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newPrice * newProducts[index].quantity;
    setValue(`transactions.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newQuantity * newProducts[index].price;
    setValue(`transactions.${index}.amount`, newAmount);
    console.log(newAmount);
  };
  if (!model) {
    return (
      <>
        <AccountingManualTransactionsDetailSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      documentNumber: model.documentNumber,
      documentDate: model.documentDate,
      companyId: model.companyId,
      transactions: model.transactions
    };

    const documentInfo = {
      title: AppEntities.AccountingManualTransactions.title,
      number: model.documentNumber,
      date: model.documentDate
    };

    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      setValue("documentNumber", data.documentNumber);
      setValue("documentDate", data.documentDate);
      setValue("companyId", data.companyId);
      setValue("transactions", data.transactions);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        /> */}
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        {/* <!-- Tabs --> */}
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <NFLookupCompany fieldName={"companyId"} title={"Company"} required={true} />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"transactions"}>
            <NFIntInput fieldName={"quantity"} title={"Quantity"} width={100} onValueChanged={handleQuantityChanged} />
            <NFIntInput fieldName={"price"} title={"Price"} width={100} onValueChanged={handlePriceChanged} />
            <NFIntInput fieldName={"amount"} title={"Amount"} width={100} />
            <NFPlainText fieldName={"productVendorCode"} title={"Product Vendor Code"} width={150} />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
              <Col sm={12}>
                <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
              </Col>
              <Col sm={6}>
                <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
              </Col>
            </Row>
          </div>
        </NFTabContainer>
      </div>
      <AccountingManualTransactionsDetailFooter />
    </FormProvider>
  );
};
